export enum HolidayKey {
  HOLIDAY = 'holiday',
  HOLIDAYS = 'holidays',
  HOLIDAYS_INFINITE = 'holidaysInfinite',
}
